/* eslint-disable */
const API_URL = process.env.REACT_APP_API_URL;
const FACEBOOK_ID = process.env.REACT_APP_FACEBOOK_ID;
const GOOGLE_ID = process.env.REACT_APP_GOOGLE_ID;

export { API_URL, FACEBOOK_ID, GOOGLE_ID };
